import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';

import {Link} from 'react-router';
import Icon from 'eventbrite_design_system/icon/Icon';
import ArrowRightChunkySvg from 'eventbrite_design_system/iconography/icons/ArrowRightChunky';

import './ArrowLink.scss';

export default class ArrowLink extends PureComponent {
    static propTypes = {
        text: EBPropTypes.translation.isRequired,
        url: PropTypes.string.isRequired,
        onClick: PropTypes.func,
    }

    render() {
        const {url, text, onClick} = this.props;

        return (
            <div className="arrow-link">
                <Link
                    to={url}
                    onClick={onClick ? () => onClick() : null}
                >
                    <div className="arrow-link--text">
                        {text}
                    </div>
                    <div className="arrow-link--icon eds-l-mar-left-1">
                        <Icon type={<ArrowRightChunkySvg />} size="xsmall" />
                    </div>
                </Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ArrowLink/ArrowLink.js